<template>
  <div class="row fit no-wrap justify-end" style="overflow: auto; gap: 20px">
    <BtnBackEdit v-if="props.propShowBtnBackEdit" />

    <BtnCancelFocusedInstitutional v-if="props.propShowBtnCancelFocusedInstitutional" />

    <BtnCancelCreateNewInstitutional v-if="props.propShowBtnCancelCreateNewCampaign" />

    <BtnEditFocusedInstitutional v-if="props.propShowBtnEditFocusedInstitutional" />

    <BtnDiscardChanges v-if="props.propShowBtnDiscardChanges" />

    <BtnSaveFocusedInstitutional
      v-if="props.propShowBtnSaveFocusedInstitutional"
      :accordionRef="props.accordionRef"
    />

    <BtnDeleteSelectedInstitutional v-if="props.propShowBtnDeleteSelectedCampaigns" />

    <BtnReviewFocusedInstitutional
      v-if="props.propShowBtnReviewFocusedCampaign"
      :accordionRef="props.accordionRef"
    />

    <BtnRequestAdjustmentsToFocusedInstitutional v-if="props.propShowBtnRequestAdjustmentsToFocusedInstitutional" />

    <BtnSendFocusedInstitutionalToApprove v-if="props.propShowBtnSendFocusedInstitutionalToApprove" />

    <BtnResendFocusedInstitutionalToApprove v-if="props.propShowBtnResendFocusedInstitutionalToApprove" 
    :accordionRef="accordionRef"/>

    <BtnApproveFocusedInstitutional v-if="props.propShowBtnApproveFocusedInstitutional" />

    <BtnPublishFocusedInstitutional v-if="props.propShowBtnPublishFocusedInstitutional" />

    <BtnViewInstitutionalDistribution v-if="props.propShowBtnViewCampaignDistribution" />
  </div>
</template>

<script setup lang="ts">
import BtnCancelFocusedInstitutional from '../actionButtons/BtnCancelFocusedInstitutional.vue'
import BtnViewInstitutionalDistribution from '../actionButtons/BtnViewInstitutionalDistribution.vue'
import BtnCancelCreateNewInstitutional from '../actionButtons/BtnCancelCreateNewInstitutional.vue'
import BtnEditFocusedInstitutional from '../actionButtons/BtnEditFocusedInstitutional.vue'
import BtnReviewFocusedInstitutional from '../actionButtons/BtnReviewFocusedInstitutional.vue'
import BtnSendFocusedInstitutionalToApprove from '../actionButtons/BtnSendFocusedInstitutionalToApprove.vue'
import BtnResendFocusedInstitutionalToApprove from '../actionButtons/BtnResendFocusedInstitutionalToApprove.vue'
import BtnApproveFocusedInstitutional from '../actionButtons/BtnApproveFocusedInstitutional.vue'
import BtnPublishFocusedInstitutional from '../actionButtons/BtnPublishFocusedInstitutional.vue'
import BtnBackEdit from '@/components/campaign/actionButtons/BtnBackEdit.vue'
import BtnDiscardChanges from '../actionButtons/BtnDiscardChanges.vue'
import BtnDeleteSelectedInstitutional from '../actionButtons/BtnDeleteSelectedInstitutional.vue'
import BtnRequestAdjustmentsToFocusedInstitutional from '../actionButtons/BtnRequestAdjustmentsToFocusedInstitutional.vue'
import BtnSaveFocusedInstitutional from '../actionButtons/BtnSaveFocusedInstitutional.vue'

const props = defineProps({
  propShowBtnBackEdit: { type: Boolean, required: false, default: false },
  propShowBtnCancelFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnCancelCreateNewCampaign: { type: Boolean, required: false, default: false },
  propShowBtnEditFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnDiscardChanges: { type: Boolean, required: false, default: false },
  propShowBtnSaveFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnDeleteSelectedCampaigns: { type: Boolean, required: false, default: false },
  propShowBtnReviewFocusedCampaign: { type: Boolean, required: false, default: false },
  propShowBtnRequestAdjustmentsToFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnSendFocusedInstitutionalToApprove: { type: Boolean, required: false, default: false },
  propShowBtnResendFocusedInstitutionalToApprove: { type: Boolean, required: false, default: false },
  propShowBtnApproveFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnPublishFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnViewCampaignDistribution: { type: Boolean, required: false, default: false },
  accordionRef: { type: Object, required: false, default: null }
})
</script>

<style scoped></style>
